<document-upload-desktop
  [attachmentName]="attachmentName"
  [attachmentTypeName]="attachmentTypeName"
  [attachmentHint]="attachmentHint"
  [id]="
    document.rootEntityType +
    '-' +
    document.rootEntityId +
    '-' +
    document.relatedEntityType +
    '-' +
    document.relatedEntityId +
    '-' +
    document.type +
    (document.id ? '-' + document.id : '')
  "
  [canUploadDocuments]="isCanUploadDocuments"
  [canRemoveDocuments]="canRemoveDocuments"
  [isShowDeferredRequiredTag]="isShowDeferredRequiredTag"
  [requiredLaterTooltip]="requiredLaterTooltip"
  documentFileNameBtnClass="linebreak-anywhere"
  [uploadedDocument]="document"
  [isRequired]="isRequiredDocument"
  [isLoading]="isLoading"
  [isStripeLayout]="true"
  [isStretched]="true"
  (upload)="onUploadFile($event)"
  (remove)="onRemoveFile($event)"
  (stateUpdate)="onStateUpdate($event)"
></document-upload-desktop>
